import { IListing } from '../@types/listing';
import { isKnockIntegrated } from '../shared/integrations/utils';
import { Knock } from './knock';
import { Rentgrata } from './rentgrata';
import { BaseIntegrationResult } from './types/base';

export type ServiceKeyWithMore =
  | 'more'
  | 'chat'
  | 'contact'
  | 'schedule'
  | 'prices'
  | 'availability'
  | 'photos'
  | 'neighborhood'
  | 'requestText';

export type IntegrationSerializedResult = {
  desktop: {
    moreIcon: boolean;
  };
  mobile: {
    moreIcon: boolean;
  };
  knock: BaseIntegrationResult<Knock>;
  rentgrata: BaseIntegrationResult<Rentgrata>;
};

export class IntegrationsFactory {
  listing: IListing;

  constructor(listing: IListing) {
    this.listing = listing;
  }

  create(): IntegrationSerializedResult {
    const hasKnock = isKnockIntegrated(this.listing);

    return {
      desktop: {
        moreIcon: hasKnock && this.listing.has_desktop_more_icon,
      },
      mobile: {
        moreIcon: hasKnock && this.listing.has_mobile_more_icon,
      },
      knock: new Knock(this.listing).serialize(),
      rentgrata: new Rentgrata(this.listing).serialize(),
    };
  }
}
